//
// Folder.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./ReportCollectionOwner";
import "../media/FolderMetadata";
import "./TransportModelReference";
import "./Connection";

var Folder = createModule("transport::Folder", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::ReportCollectionOwner"], EventDispatcher, [
    ,
    {
        isExpanded: 2,
        parent: 1,
        lastUpdated: 9,
        fileReferences: [1],
        isSubscribed: 2,
        depth: 4,
        lastVisited: 9,
        meta: 1,
        connection: 1,
        folderReferences: [1],
    },
    ,
    ,
    {
        toString2: [7],
        getPath: [7],
    },
    {
        _create: [4],
    },
    ,
]);
export default Folder;
